export const arrayReducer = (array, prop) => {
  let sum = 0
  array.forEach((elem) => {
    sum += parseInt(elem[prop])
  })
  // console.log(sum)
  return sum
}
